import React, { useState } from "react";
// import emailjs from "@emailjs/browser";
// import { postToStrapi } from "../api/strapi";

const EMPTY_FORM = { name: "", email: "", company: "", message: "" };

export default function EnquiryModal({ isOpen, onClose }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const handleClose = () => {
    if (submitting) return;
    setSuccess(false);
    setError("");
    setForm(EMPTY_FORM);
    onClose();
  };

  const handleChange = e =>
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setError("");
    try {
      setSubmitting(true);

      // // Save to Strapi
      // await postToStrapi("/ecl-contact-enquiries", {
      //   data: {
      //     Name: form.name,
      //     Email: form.email,
      //     Company: form.company,
      //     Message: form.message,
      //   },
      // });

      // // Send email via EmailJS → SendGrid
      // await emailjs.send(
      //   process.env.REACT_APP_EMAILJS_SERVICE_ID,
      //   process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      //   {
      //     from_name: form.name,
      //     from_email: form.email,
      //     company: form.company || "—",
      //     message: form.message,
      //     to_email: "support@ecl-global.com",
      //   },
      //   process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      // );

      const res = await fetch("/.netlify/functions/send-inquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          company: form.company,
          message: form.message,
        }),
      });

      if (!res.ok) throw new Error("Failed to send");

      setSuccess(true);
    } catch (err) {
      console.error("Enquiry submission failed:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(10,26,58,0.65)",
        backdropFilter: "blur(4px)",
        zIndex: 1050,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
      onClick={handleClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          width: "100%",
          maxWidth: 480,
          boxShadow: "0 24px 64px rgba(0,0,0,0.22)",
          overflow: "hidden",
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Accent bar */}
        {/* style={{ height: 4, background: "linear-gradient(90deg, #009EDC, #00ddff)" }} */}
        <div  />

        <div style={{ padding: "32px 36px" }}>
          {success ? (
            <div style={{ textAlign: "center", padding: "24px 0" }}>
              <div style={{
                width: 64, height: 64, borderRadius: "50%", background: "#fff",
                display: "flex", alignItems: "center", justifyContent: "center",
                margin: "0 auto 20px",
              }}>
                <i className="bi bi-check-lg" style={{ color: "#fff", fontSize: 28 }} />
              </div>
              <h5 className="fw-bold mb-2" style={{ color: "#0a1a3a" }}>Message received!</h5>
              <p style={{ color: "#919191", marginBottom: 24, fontSize: "0.9rem" }}>
                Our team will be in touch with you shortly.
              </p>
              <button className="btn btn-dark px-4" onClick={handleClose}>Close</button>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-start mb-4">
                <div>
                  <h5 className="fw-bold mb-1" style={{ color: "#0a1a3a" }}>Let's get started</h5>
                  <p style={{ color: "#919191", fontSize: "0.85rem", margin: 0 }}>
                    Tell us a bit about yourself and we'll reach out.
                  </p>
                </div>
                <button className="btn-close ms-3 mt-1" onClick={handleClose} aria-label="Close" />
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row g-3 mb-3">
                  <div className="col-12 col-sm-6">
                    <label className="form-label small fw-semibold">Full name *</label>
                    <input
                      type="text" name="name" className="form-control"
                      placeholder="Kwame Asante" required
                      value={form.name} onChange={handleChange}
                    />
                  </div>
                  <div className="col-12 col-sm-6">
                    <label className="form-label small fw-semibold">Work email *</label>
                    <input
                      type="email" name="email" className="form-control"
                      placeholder="kwame@company.com" required
                      value={form.email} onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-semibold">
                    Company{" "}
                    <span style={{ color: "#9CA3AF", fontWeight: 400 }}>(optional)</span>
                  </label>
                  <input
                    type="text" name="company" className="form-control"
                    placeholder="Acme Ltd."
                    value={form.company} onChange={handleChange}
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label small fw-semibold">How can we help? *</label>
                  <textarea
                    name="message" className="form-control" rows={4}
                    placeholder="Tell us about your business challenge or what you're looking to achieve…"
                    required value={form.message} onChange={handleChange}
                    style={{ resize: "none" }}
                  />
                </div>

                {error && <p className="text-danger small mb-3">{error}</p>}

                <button
                  type="submit"
                  className="btn w-100 fw-semibold"
                  disabled={submitting}
                  style={{ backgroundColor: "#0a1a3a", color: "#fff", borderRadius: 8, padding: "10px 0" }}
                >
                  {submitting ? "Sending…" : "Send message"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
